import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ContentWarningIcon from '../../../mini/ContentWarningIcon'
import P3 from '../../../typography/paragraphs/P3'

const ContentWarningRow = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 0;
  margin-top: 17px;

  .content-warning-icon {
    margin-left: 0;
  }
`

const ContentWarningItem = ({ contentWarning }) => (
  <ContentWarningRow>
    <ContentWarningIcon
      value={contentWarning.value}
      text={contentWarning.text}
      abbrev={contentWarning.abbrev}
    />
    <P3 style={{ color: '#000000' }}>{contentWarning.text}</P3>
  </ContentWarningRow>
)

ContentWarningItem.propTypes = {
  contentWarning: PropTypes.object.isRequired
}

export default ContentWarningItem



// WEBPACK FOOTER //
// ./src/components/quest/basicinformation/contentwarnings/ContentWarningItem.js